import { render, staticRenderFns } from "./registrationRecord.vue?vue&type=template&id=72597121&"
import script from "./registrationRecord.vue?vue&type=script&lang=js&"
export * from "./registrationRecord.vue?vue&type=script&lang=js&"
import style0 from "./registrationRecord.vue?vue&type=style&index=0&id=72597121&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports